import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, brl } from "../../lib/api";
import { ScoreRing } from "../../components/Score";

export default function ClientDashboard() {
  const [installments, setInstallments] = useState([]);
  const [client, setClient] = useState(null);
  const [sales, setSales] = useState([]);

  useEffect(() => {
    (async () => {
      const [i, c, s] = await Promise.all([api.get("/installments"), api.get("/clients"), api.get("/sales")]);
      setInstallments(i.data); setClient(c.data[0] || null); setSales(s.data);
    })();
  }, []);

  const pending = installments.filter((x) => x.status !== "paid");
  const totalOpen = pending.reduce((a, b) => a + Number(b.amount), 0);
  const nextDue = pending.sort((a, b) => a.due_date.localeCompare(b.due_date))[0];

  return (
    <div data-testid="client-dashboard">
      <div className="topbar">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Sua conta</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-1">{client?.name || "Bem-vinda"}</h1>
        </div>
        <Link to="/cliente/parcelas" className="brand">Minhas parcelas</Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        {client && (
          <div className="border border-[#EBE5DF] bg-white p-6 flex flex-col items-center">
            <ScoreRing score={client.score} />
            <div className="text-[10px] tracking-widest uppercase text-[#5C5A57] mt-4">Seu score</div>
          </div>
        )}
        <div className="border border-[#EBE5DF] bg-[#F5F0EB] p-6">
          <div className="kpi-label">Saldo aberto</div>
          <div className="kpi-value tabular">{brl(totalOpen)}</div>
          <div className="text-xs text-[#5C5A57] mt-2">{pending.length} parcela(s) pendentes</div>
        </div>
        <div className="border border-[#EBE5DF] bg-white p-6">
          <div className="kpi-label">Proxima parcela</div>
          {nextDue ? (
            <>
              <div className="font-display text-2xl font-bold tabular mt-2">{brl(nextDue.amount)}</div>
              <div className="text-xs text-[#5C5A57] mt-1">Vence em {new Date(nextDue.due_date).toLocaleDateString("pt-BR")}</div>
            </>
          ) : <div className="text-xs text-[#5C5A57] mt-2">Tudo em dia.</div>}
        </div>
      </div>

      <h2 className="section-title mb-4">Suas compras</h2>
      <div className="table-wrap">
        <table className="crl">
          <thead><tr><th>#</th><th>Data</th><th>Total</th><th>Parcelas</th><th></th></tr></thead>
          <tbody>
            {sales.map((s) => (
              <tr key={s.id}>
                <td>#{s.number}</td>
                <td className="text-[#5C5A57] text-xs">{new Date(s.created_at).toLocaleDateString("pt-BR")}</td>
                <td className="tabular font-medium">{brl(s.total)}</td>
                <td>{s.installments}x</td>
                <td><Link to={`/vendas/${s.id}`} className="text-xs tracking-widest uppercase font-medium hover:underline">Ver</Link></td>
              </tr>
            ))}
            {sales.length === 0 && <tr><td colSpan="5" className="text-center text-sm text-[#5C5A57] py-8">Sem compras ainda.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
